"use client";

import { useState, useEffect } from "react";
import { Card, Button, message, Divider } from "antd";
import { DeleteOutlined, BookOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import NoAudioBookSaved from "../sharedcomponents/NoBookFound";
import type { IBookTypeData } from "../../apiservice/userService.type";

const BookmarksPage = () => {
  const [bookmarks, setBookmarks] = useState<IBookTypeData[]>([]);

  // Load bookmarks from localStorage on component mount
  useEffect(() => {
    try {
      const storedBookmarks = localStorage.getItem("bookmarks");
      if (storedBookmarks) {
        setBookmarks(JSON.parse(storedBookmarks));
      }
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  // Remove a bookmark
  const removeBookmark = (bookId: string) => {
    const updatedBookmarks = bookmarks.filter(
      (book) => book.id !== Number(bookId)
    );
    setBookmarks(updatedBookmarks);
    localStorage.setItem("bookmarks", JSON.stringify(updatedBookmarks));
    message.success("Book removed from bookmarks");
  };

  // Clear all bookmarks
  const clearAllBookmarks = () => {
    setBookmarks([]);
    localStorage.removeItem("bookmarks");
    message.success("All bookmarks cleared");
  };

  return (
    <>
      <div className="container mx-auto bg-gray-50 dark:bg-stone-900 min-h-screen p-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-stone-100">
            My Bookmarks
          </h1>
          {bookmarks.length > 0 && (
            <Button
              danger
              onClick={clearAllBookmarks}
              icon={<DeleteOutlined />}
              className="dark:bg-red-600 dark:text-white dark:border-red-600 dark:hover:bg-red-700"
            >
              Clear All
            </Button>
          )}
        </div>

        {bookmarks.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {(bookmarks || []).map((book) => (
              <Card
                key={book.id}
                hoverable
                className="[&_.ant-card-body]:bg-white [&_.ant-card-body]:dark:bg-stone-800 [&_.ant-card-actions]:bg-white [&_.ant-card-actions]:dark:bg-stone-700 [&_.ant-card-actions]:border-t [&_.ant-card-actions]:border-gray-200 [&_.ant-card-actions]:dark:border-stone-600 bg-white dark:bg-stone-800 border-0 shadow-md dark:shadow-stone-900/20"
                cover={
                  <img
                    alt={book.title}
                    src={`${process.env.PUBLIC_URL + book.coverImageUrl}`}
                    className="h-48 object-cover"
                  />
                }
                actions={[
                  <Link
                    to={`/users/book-details/${book.id}/${encodeURIComponent(
                      book.title.replace(/\s+/g, "_")
                    )}`}
                    key="view"
                  >
                    <Button
                      className="border-0 bg-transparent text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:bg-red-50 dark:hover:bg-blue-900/20 shadow-none"
                      type="text"
                      key="remove"
                    >
                      <BookOutlined /> View
                    </Button>
                  </Link>,
                  <Button
                    className="border-0 bg-transparent text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 shadow-none"
                    type="text"
                    danger
                    onClick={() => removeBookmark(book.id + "")}
                    key="remove"
                  >
                    <DeleteOutlined /> Trash
                  </Button>,
                ]}
              >
                <Card.Meta
                  title={
                    <span className="text-gray-900 dark:text-stone-100 font-semibold">
                      {book.title}
                    </span>
                  }
                  description={
                    <span className="text-gray-600 dark:text-stone-400">
                      {book.authorName}
                    </span>
                  }
                />
                <Divider className="border-gray-200 dark:border-stone-600 my-3" />
                <div className="flex flex-wrap gap-1">
                  {/* {book.categories.map((cat) => (
                    <span
                      key={cat.id}
                      className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300 rounded-full"
                    >
                      {cat.bookCategory.title}
                    </span>
                  ))} */}
                  {/* {book.isNewRelease && (
                    <span className="px-2 py-0.5 text-xs bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300 rounded-full">
                      New Release
                    </span>
                  )} */}
                </div>
              </Card>
            ))}
          </div>
        ) : (
          <div className="dark:bg-stone-900">
            <NoAudioBookSaved />
          </div>
        )}
      </div>
    </>
  );
};

export default BookmarksPage;
